import { useCallback, useState } from 'react';

import { useOpenEmailAttachmentMutation } from 'core/graphql';

import { IRichMailError, richMailError } from './richMailModel';

/**
 * ТЗ 0097 — открыть вложение письма: сервер достаёт файл (входящее — из
 * Gmail по требованию) и отдаёт подписанную ссылку на 300 с.
 *
 * Вкладку открываем СРАЗУ, по клику, а адрес ставим после ответа: окно,
 * открытое после `await`, браузер считает всплывающим и блокирует.
 */
export const useEmailAttachmentLink = () => {
  const [linkMut] = useOpenEmailAttachmentMutation();
  const [busyKey, setBusyKey] = useState<string | null>(null);

  const open = useCallback(
    async (
      messageId: string,
      index: number,
    ): Promise<IRichMailError | null> => {
      const key = `${messageId}:${index}`;
      const tab = window.open('', '_blank');
      if (tab) tab.opener = null;
      setBusyKey(key);
      try {
        const { data } = await linkMut({ variables: { messageId, index } });
        const url = data?.emailAttachmentLink;
        if (!url) {
          tab?.close();
          return { code: 'NOT_FOUND', message: '' };
        }
        if (tab) tab.location.href = url;
        else window.location.assign(url);
        return null;
      } catch (caught) {
        tab?.close();
        return richMailError(caught);
      } finally {
        setBusyKey(null);
      }
    },
    [linkMut],
  );

  return { open, busyKey };
};
